const productBase = "/fustellificio-far/products";

const farProducts = [
	{
		slug: "lamaonda-corrugato-pro",
		name: "Lamaonda Corrugato Pro",
		category: "Fustelle per packaging",
		price: 148,
		leadTime: "Pronta in 48h",
		image: `${productBase}/07e94932-3cd3-4724-8bdc-52e58add2293.jpg`,
		finish: "Acciaio lucidato e canali cordonatura",
		description:
			"Fustella modulare per cartone ondulato, pensata per tagli netti, cordonature stabili e tirature ripetute senza deriva dimensionale.",
		specs: ["Formato 420 x 520 mm", "Lama 23,8 mm", "Espulsori in gomma tecnica"],
	},
	{
		slug: "tagliopieno-espositore",
		name: "Tagliopieno Espositore",
		category: "Display da banco",
		price: 196,
		leadTime: "Setup incluso",
		image: `${productBase}/1cb7e331-f7b4-4ebc-8f66-806aa7608def.jpg`,
		finish: "Lama mista taglio e mezzo taglio",
		description:
			"Soluzione per espositori compatti, con incastri puliti e cordoni calibrati per montaggi rapidi in punto vendita.",
		specs: ["Fino a 2 mm", "Microperforazione opzionale", "Registro rinforzato"],
	},
	{
		slug: "cartesio-scatola-fondo",
		name: "Cartesio Fondo Rapido",
		category: "Scatole automatiche",
		price: 232,
		leadTime: "Campione digitale",
		image: `${productBase}/2a666f6d-f829-44e0-9ffe-e29c5866e476.jpg`,
		finish: "Profilo fondo automatico",
		description:
			"Fustella per scatole a fondo rapido con geometrie pensate per velocizzare piega, incollaggio e assemblaggio.",
		specs: ["Cartoncino 280-600 g", "Ponti anti-strappo", "Codifica laser"],
	},
	{
		slug: "incastro-vivo-vassoi",
		name: "Incastro Vivo Vassoi",
		category: "Vassoi e alveari",
		price: 174,
		leadTime: "Pronta in 72h",
		image: `${productBase}/473409f3-1fdf-477d-8da0-2e5e916a28b6.jpg`,
		finish: "Cordonatura profonda",
		description:
			"Per vassoi tecnici e alveari protettivi, bilancia precisione di taglio e resistenza degli incastri.",
		specs: ["Alveari componibili", "Spessori variabili", "Prova montaggio inclusa"],
	},
	{
		slug: "linea-pack-ecommerce",
		name: "Linea Pack E-commerce",
		category: "Spedizioni",
		price: 215,
		leadTime: "Configurabile",
		image: `${productBase}/6f73bddf-98b5-4cf1-96a5-b747e1e6be52.jpg`,
		finish: "Chiusura con linguetta",
		description:
			"Fustella per mailer box e packaging e-commerce, con apertura guidata e pieghe stabili per produzioni scalabili.",
		specs: ["Strappo facilitato", "Doppia cordonatura", "Compatibile kraft e teso"],
	},
	{
		slug: "microforo-etichette",
		name: "Microforo Etichette",
		category: "Carta e adesivi",
		price: 129,
		leadTime: "Alta precisione",
		image: `${productBase}/8044b448-acef-4bee-b664-83c541a46843.jpg`,
		finish: "Mezzo taglio controllato",
		description:
			"Fustella dedicata a etichette, fascette e piccoli formati, con taglio preciso su supporti adesivi e carte speciali.",
		specs: ["Tolleranza fine", "Mezzo taglio", "Riduzione sfrido"],
	},
	{
		slug: "cordone-lux-astuccio",
		name: "Cordone Lux Astuccio",
		category: "Astucci premium",
		price: 268,
		leadTime: "Finitura premium",
		image: `${productBase}/9fd9c54d-1f42-4454-a2e7-e3a04a50c688.jpg`,
		finish: "Cordonatura morbida per carte pregiate",
		description:
			"Fustella per astucci cosmetica, food e retail premium, studiata per evitare screpolature su carte accoppiate o laminate.",
		specs: ["Carte laminate", "Piega morbida", "Impronta pulita"],
	},
	{
		slug: "finestra-nitida-pack",
		name: "Finestra Nitida Pack",
		category: "Packaging finestrato",
		price: 188,
		leadTime: "Taglio pulito",
		image: `${productBase}/ae0f925b-e8fa-4fdd-995a-d8b1265e66da.jpg`,
		finish: "Perimetro finestra rinforzato",
		description:
			"Per scatole finestrate e sleeve prodotto, con raggi ottimizzati per ridurre strappi e imprecisioni sul bordo vista.",
		specs: ["Raggi morbidi", "Sleeve e astucci", "Bordo anti-sfilaccio"],
	},
	{
		slug: "ondaferma-grande-formato",
		name: "Ondaferma Grande Formato",
		category: "Cartone ondulato",
		price: 304,
		leadTime: "Su misura",
		image: `${productBase}/c948460e-c9e3-47d3-b7bc-b5d0999b0afe.jpg`,
		finish: "Telaio rinforzato",
		description:
			"Fustella grande formato per cartone ondulato e protezioni industriali, stabile anche su formati importanti.",
		specs: ["Telaio extra", "Taglio profondo", "Controllo planarita"],
	},
	{
		slug: "zipline-apertura-facile",
		name: "Zipline Apertura Facile",
		category: "Packaging intelligente",
		price: 246,
		leadTime: "Demo montaggio",
		image: `${productBase}/dd0e4ec4-7381-48cb-a395-84c9f97874cf.jpg`,
		finish: "Strappo guidato e perforazione",
		description:
			"Fustella con apertura facilitata per packaging consumer, ideale quando l'esperienza di apertura conta quanto la protezione.",
		specs: ["Perforazione zip", "Apertura controllata", "Test ergonomico"],
	},
	{
		slug: "alveo-protezione-interna",
		name: "Alveo Protezione Interna",
		category: "Interni scatola",
		price: 159,
		leadTime: "Batch rapido",
		image: `${productBase}/f8b88698-2eae-42c5-a1a9-a4690fec3699.jpg`,
		finish: "Incastri tecnici",
		description:
			"Per inserti interni, separatori e protezioni sagomate, con incastri precisi e sfrido contenuto.",
		specs: ["Separatori modulari", "Incastro secco", "Ottimizzazione lastra"],
	},
	{
		slug: "atelier-prototipo-pack",
		name: "Atelier Prototipo Pack",
		category: "Prototipazione",
		price: 118,
		leadTime: "Bozza veloce",
		image: `${productBase}/grok-image-8d9272d1-0003-4e4b-baa6-233ce3ce15eb.jpg`,
		finish: "Serie pilota",
		description:
			"Pacchetto demo per validare una nuova scatola prima della produzione: geometria, materiali e montaggio in un unico ciclo.",
		specs: ["Pre-serie", "File tecnico incluso", "Revisione forma"],
	},
];

export default farProducts;
